import React, { createContext, useState, useContext, useEffect } from "react";

// Create the context
const CompletedTimersContext = createContext();

// Custom hook to use the context
export const useCompletedTimers = () => {
  const context = useContext(CompletedTimersContext);
  if (!context) {
    throw new Error(
      "useCompletedTimers must be used within a CompletedTimersProvider"
    );
  }
  return context;
};

// Provider component
export const CompletedTimersProvider = ({ children }) => {
  const [completedTimers, setCompletedTimers] = useState([]);

  // Add a timer to the completed list
  const addCompletedTimer = (booking) => {
    setCompletedTimers((prev) => {
      // Check if this booking is already in the list to avoid duplicates
      if (!prev.some((timer) => timer._id === booking._id)) {
        return [...prev, booking];
      }
      return prev;
    });
  };

  // Remove a timer from the completed list
  const removeCompletedTimer = (bookingId) => {
    setCompletedTimers((prev) =>
      prev.filter((timer) => timer._id !== bookingId)
    );
  };

  // Get the count of completed timers
  const getCompletedTimersCount = () => completedTimers.length;

  // Value object to be provided to consumers
  const value = {
    completedTimers,
    addCompletedTimer,
    removeCompletedTimer,
    getCompletedTimersCount,
  };

  return (
    <CompletedTimersContext.Provider value={value}>
      {children}
    </CompletedTimersContext.Provider>
  );
};

export default CompletedTimersContext;
